<template>
  <Pill v-if="isAvailable()" variant="highlight">
    <div>Get ${{ getAmount() }}</div>
  </Pill>
</template>

<script>
import { getAmount, isAvailable } from "@/utils/referAFriendPromo";
import Pill from "@/components/display/Pill";

export default {
  name: "ReferAFriendPromotionMenuItemAddon",
  components: { Pill },
  setup: () => ({ getAmount, isAvailable }),
};
</script>
